import * as angular from 'angular';
import * as c3 from 'c3';
import * as d3 from 'd3';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('pkpPreviousRoundsGraph', pkpPreviousRoundsGraph);

    /**
     * This is a directive for the previous rounds graph.
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpPreviousRoundsGraph(authService, appMemoryService) {
        return {
            restrict: 'E',
            scope: {
                windows: '=',
                logged: '='
            },
            template:
                require('app/_directives/pkp-previous-rounds-graph.directive.html'),
            link: function postLink(scope, iElement) {
                var graphData = buildGraphData(scope.windows);

                var regions = [];
                for (var i = 0; i < graphData.regions.length; i++) {
                    regions[i] = {
                        axis: 'x',
                        class: 'regionX',
                        start: graphData.regions[i].start,
                        end: graphData.regions[i].end
                    };
                }

                var maxs = 0;
                for (var j = 0; j < graphData.sceneround.length; j++) {
                    var values = [
                        graphData.sceneround[j].Marketable,
                        graphData.sceneround[j]['Total Requested Capacity']
                    ];
                    if (angular.isNumber(graphData.sceneround[j]['Your Bid'])) {
                        values.push(graphData.sceneround[j]['Your Bid']);
                    }
                    var maxtemp = Math.max(...values);
                    maxs = Math.max(maxs, maxtemp);
                }

                var chart = buildGraph(
                    $(iElement[0]).children()[0],
                    graphData,
                    regions,
                    maxs
                );

                //watch parent width, to use the right size for the graph.
                var unbindParentElemWidthWatcher = scope.$watch(
                    function () {
                        try {
                            return iElement.parent().width();
                        } catch (E) {}
                    },
                    function (width) {
                        if (!width || width <= 0) {
                            return;
                        }

                        chart.resize();
                        unbindParentElemWidthWatcher();
                    }
                );
            }
        };

        function buildGraphData(windows) {
            var chartData: any = {
                surchargedata: [],
                ratiodata: [],
                variables: {},
                sceneround: [],
                regions: []
            };

            if (!angular.isUndefined(windows)) {
                for (var i = 0; i < windows.length; i++) {
                    var window = windows[i];
                    var round = window.roundNumber;

                    for (
                        var j = 0;
                        j < window.windowAuctionSurcharge.length;
                        j++
                    ) {
                        chartData.surchargedata[i] = {
                            round: round,
                            surcharge:
                                window.windowAuctionSurcharge[j].value.value,
                            unit: window.windowAuctionSurcharge[j].unit.label
                        };
                    }

                    chartData.sceneround[i] = {
                        round: round,
                        Marketable: window.marketedQuantity.value.value,
                        'Total Requested Capacity':
                            window.totalRequestedQuantity.value.value
                    };
                    if (!!authService.getLoggedInUser()) {
                        if (!angular.isUndefined(window.myRequestedQuantity)) {
                            chartData.sceneround[i]['Your Bid'] =
                                window.myRequestedQuantity.value.value;
                        } else {
                            chartData.sceneround[i]['Your Bid'] = 0;
                        }
                    }

                    var ratio: string | number = '?%';
                    if (
                        window.totalRequestedQuantity.unit ===
                        window.marketedQuantity.unit
                    ) {
                        ratio =
                            (window.totalRequestedQuantity.value.value /
                                window.marketedQuantity.value.value) *
                            100;
                    }
                    chartData.ratiodata[i] = {
                        round: round,
                        ratio: ratio
                    };

                    if (round.indexOf('.0') == -1) {
                        chartData.regions.push({
                            start: i,
                            end: i + 1
                        });
                    }
                }

                chartData.variables = {
                    unit: ''
                };

                if (windows.length > 0) {
                    chartData.variables.unit = windows[0].marketedQuantity.unit;
                } else {
                    appMemoryService.platformSettings(
                        function (res) {
                            if (res.amount === 'MEGA') {
                                chartData.variables.unit = 'MWh/h';
                            } else if (res.amount === 'KILO') {
                                chartData.variables.unit = 'kWh/h';
                            }
                        },
                        function () {
                            chartData.variables.unit = 'kWh/h';
                        }
                    );
                }
            }

            return chartData;
        }

        function buildGraph(elem, graphData, regions, maxs) {
            var keys = ['Marketable', 'Total Requested Capacity'];
            if (!!authService.getLoggedInUser()) {
                keys.push('Your Bid');
            }

            var c3Gaph = c3.generate({
                bindto: elem,
                data: {
                    json: graphData.sceneround,
                    selection: {
                        enabled: false
                    },
                    keys: {
                        x: 'round',
                        value: keys
                    },
                    types: {
                        Marketable: 'area'
                    },
                    colors: {
                        Marketable: '#418bca',
                        'Total Requested Capacity': '#272E80',
                        'Your Bid': '#00888A'
                    }
                },
                point: {
                    show: false
                },
                axis: {
                    x: {
                        type: 'category',
                        label: {
                            text: 'Round Number',
                            position: 'outer-center'
                        }
                    },
                    y: {
                        min: 0,
                        padding: {
                            bottom: 0
                        },
                        tick: {
                            values: [0, maxs],
                            format: function (d) {
                                return (
                                    d3.format(',3f')(d) +
                                    ' ' +
                                    graphData.variables.unit
                                );
                            }
                        }
                    }
                },
                grid: {
                    y: {
                        lines: []
                    }
                },
                legend: {
                    position: 'right'
                },
                regions: regions,
                tooltip: {
                    contents: function (
                        d,
                        defaultTitleFormat,
                        defaultValueFormat,
                        color
                    ) {
                        var $$ = this,
                            config = $$.config,
                            CLASS = $$.CLASS,
                            titleFormat =
                                config.tooltip_format_title ||
                                defaultTitleFormat,
                            nameFormat =
                                config.tooltip_format_name ||
                                function (name) {
                                    return name;
                                },
                            valueFormat =
                                config.tooltip_format_value ||
                                defaultValueFormat,
                            text,
                            i,
                            title,
                            value,
                            name,
                            bgcolor;
                        var count = 0;
                        for (i = 0; i < d.length; i++) {
                            if (!(d[i] && (d[i].value || d[i].value === 0))) {
                                continue;
                            }
                            if (!text) {
                                title =
                                    'Round: ' +
                                    graphData.sceneround[d[i].index].round +
                                    ', Ratio: ' +
                                    Math.round(
                                        graphData.ratiodata[d[i].index].ratio *
                                            100
                                    ) /
                                        100 +
                                    ' %';
                                text =
                                    "<table class='" +
                                    CLASS.tooltip +
                                    "'>" +
                                    (title || title === 0
                                        ? "<tr><th colspan='2'>" +
                                          title +
                                          '</th></tr>'
                                        : '');
                            }
                            name = nameFormat(d[i].name);
                            value = valueFormat(
                                d[i].value,
                                d[i].ratio,
                                d[i].id,
                                d[i].index
                            );
                            bgcolor = $$.levelColor
                                ? $$.levelColor(d[i].value)
                                : color(d[i].id);
                            text +=
                                "<tr class='" +
                                CLASS.tooltipName +
                                '-' +
                                d[i].id +
                                "'>";
                            text += `<td class="name"><span ng-style="{ 'background-color': '${bgcolor}', 'border-radius': '5px' }"></span>${name}</td>`;
                            text += "<td class='value'>" + value + '</td>';
                            text += '</tr>';
                        }
                        text +=
                            "<tr class='" +
                            CLASS.tooltipName +
                            '-surchargedata' +
                            "'>";
                        text +=
                            "<td id='footer'>" +
                            'Surcharge: ' +
                            graphData.surchargedata[d[0].index].surcharge +
                            ' ' +
                            graphData.surchargedata[d[0].index].unit +
                            '</td>';
                        text += "<td id='footer'></td>";
                        text += '</tr></table>';
                        return text;
                    }
                }
            });

            return c3Gaph;
        }
    }
})();
